import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'external-banner-details-popup:unavailable-nearby-stores': {
    id: 'external-banner-details-popup:unavailable-nearby-stores',
    defaultMessage: 'Unavailable at nearby stores',
    description:
      'Message indicating that the offer is unavailable at nearby stores in the external banner details popup',
  },
});
